var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M12.8 24.5H9.7c-1 0-1.8-.8-1.8-1.8v-3.1c0-1 .8-1.8 1.8-1.8h3.1c1 0 1.8.8 1.8 1.8v3.1c.1.9-.8 1.8-1.8 1.8zM12.8 13H9.7c-1 0-1.8-.8-1.8-1.8V8.1c0-1 .8-1.8 1.8-1.8h3.1c1 0 1.8.8 1.8 1.8v3.1c.1 1-.8 1.8-1.8 1.8zM12.8 35.9h-3c-1 0-1.8-.8-1.8-1.8V31c0-1 .8-1.8 1.8-1.8h3.1c1 0 1.8.8 1.8 1.8v3.1c0 1-.9 1.8-1.9 1.8zM20.7 9.6h13.4M20.7 21.1h13.4M20.7 32.6h13.4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxGroup);
export default __webpack_public_path__ + "static/media/checkboxGroup.d999f71539ffa4920d22526e6167621f.svg";
export { ForwardRef as ReactComponent };